export default __webpack_public_path__ + "static/media/ReportDarkInActive.4ab93dae.svg";